/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule, LazyloadService } from '@dm/core';

import { ClientCifsShareComponent } from './client-cifs-share.component';
import { ClientCifsShareService } from './client-cifs-share.service';
import { ModifyClientCifsShareModule } from './modify-client-cifs-share/modify-client-cifs-share.module';
import { RemoveClientCifsShareModule } from './remove-client-cifs-share/remove-client-cifs-share.module';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        RemoveClientCifsShareModule,
        ModifyClientCifsShareModule,
    ],
    declarations: [ClientCifsShareComponent],
    exports: [ClientCifsShareComponent],
    providers: [
        LazyloadService,
        ClientCifsShareService,
    ],
})
export class ClientCifsShareModule { }

